/* eslint-disable import/prefer-default-export */

import {
  watchSweetAlert,
} from './sweet_alert';

export const sweetAlertSaga = [
  watchSweetAlert,
];
